export default __webpack_public_path__ + "static/media/cm-own.80d5c387.png";